import { gql, useQuery } from "@apollo/client";
import { captureException } from "@sentry/react";

import FastStartBonus from "./FastStartBonus";

export default () => {
  // Fetch data
  const GET_FAST_START_DATA = gql`
    query GetFastStartData {
      fastStartData {
        coinsFound
        progress
        expires
        limit
        amount
      }
    }
  `;

  const { loading, data, error } = useQuery(GET_FAST_START_DATA, {
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("error fetching fast start data", error);
    captureException(error);
  }

  //console.log("data", data);

  return (
    <>
      {!data && <div />}
      {data && <FastStartBonus data={data} />}
    </>
  );
};
